<script lang="ts" setup>
import { ref } from 'vue';

import type { FlightAutoCompleteSuggestion } from '@libs/trip-planner-interfaces';
import { AppSvgIcon } from '@libs/ui';

import { AutoCompleteSuggestions, AutoCompleteType } from '../autoComplete';

interface AirportSelectorMobileProps {
  isDepartingAirport: boolean;
  initialAirport?: string;
}
const props = defineProps<AirportSelectorMobileProps>();

interface AirportSelectorEmits {
  (
    eventName: 'airport-selected',
    airportSuggestion: FlightAutoCompleteSuggestion | undefined
  ): void;
}
const emit = defineEmits<AirportSelectorEmits>();

const userInput = ref<string>('');

function handleAirportSelected(
  airportSuggestion: FlightAutoCompleteSuggestion | undefined
): void {
  if (airportSuggestion) {
    userInput.value = airportSuggestion?.label ?? '';
    emit('airport-selected', airportSuggestion);
  }
}
</script>

<template>
  <div class="airport-mobile-selector">
    <AutoCompleteSuggestions
      :auto-complete-type="AutoCompleteType.Airport"
      :initial-search-text="userInput || props.initialAirport || ''"
      :placeholder="
        props.isDepartingAirport
          ? $t('modals.addFlights.choose_departing_airport')
          : $t('modals.addFlights.choose_arriving_airport')
      "
      :should-focus-on-init="true"
      @airport-selected="handleAirportSelected"
      @close="handleAirportSelected(undefined)"
    >
      <template #left-icon>
        <AppSvgIcon name="airplaneTakeoff" />
      </template>
    </AutoCompleteSuggestions>
  </div>
</template>

<style lang="scss" scoped>
.airport-mobile-selector {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
